<template>
  <div class="article-detail" v-if="item">
    <!-- 上 -->
    <div>
      <div class="dw-center">
        <div class="ad-up content-wth top18-center">
          <div class="font-14 author-time xiugai">
            <div class="article-title">{{ item.title }}</div>
            <div style="margin-top: 15px">
              <span class="author">本文作者： {{ item.uname }}</span>
              <span class="time">发布时间：{{ formatDate(Date.parse(item.time)) }}</span>
            </div>
            <!-- 文章导语 -->
            <p class="intro font-14">{{ item.info }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 下 -->
    <div class="ad-down">
      <!-- 左 -->
      <div class="ad-left content-wth" style="width:100%;">
        <!-- 文章内容 -->
        <div class="ql-editor content-info"  style="width:100%;" v-html="clText(item.context)"></div>

        <p v-if="item.fileLink" style="color: #0084ff; font-size: 15px; cursor: pointer" @click="see(item.fileLink)">
          <span>查看附件</span>
        </p>

        <p v-if="item.link">
          <span v-if="(item.link||'').indexOf('http')!==0">
            其他相关知识：
            <span style="color: #0e86f6; cursor: pointer; font-size: 13px">{{ item.link }}</span>
          </span>
          <a v-else :href="item.link" target="_blank" v-show="item.link">
            链接查看地址：{{ item.link }}
          </a>
        </p>


      </div>
    </div>
  </div>
</template>

<script>
import {formatDate,} from "@/js/common/index.js";
import api from '@/services/config.js'
import {getWzById} from '@/services'

export default {
  data() {
    return {
      item: null,
      formatDate,
      id:''
    };
  },
  created() {
    let item = this.$route.params;
    let id = this.$route.query.id;
    if(!id){
      if(item&&JSON.stringify(item)!=='{}'){
        sessionStorage.setItem('wz',JSON.stringify(item));
        this.item = item
      }else{
        try {
          let str = sessionStorage.getItem('wz');
          this.item = JSON.parse(str);
        } catch (error) {
          
        }
      }
    }else{
      this.id = id;
      this.getDateil()
    }
  },
  beforeDestroy(){
    sessionStorage.removeItem('wz');
  },
  methods: {
    getDateil(){
      getWzById({arctitleId:this.id}).then(res=>{
        if(res.success){
          this.item = res.data;
        }else{
          this.$message.warning(res.message)
        }
      })
    },


    see(answerFiles) {
      window.open(api.concat(answerFiles), "_blank"); ///新建窗口
    },

    clText(val){
      if(val){
        return val.replace(/max-width/g,'width');
      }else{
        return ''
      }
    }
  }
};
</script>

<style scoped>
/* 图标 */

.refresh-icon1 {
  width: 15px;
  height: 15px;
  display: inline-block;
  background-image: url("~@/assets/icon/Fabulous.png");
  background-repeat: no-repeat;
  position: relative;
  top: 3px;
  background-size: 15px 15px;
  margin-left: 5px;
}

.refresh1-icon1 {
  width: 15px;
  height: 15px;
  display: inline-block;
  background-image: url("~@/assets/icon/Fabuloused1.png");
  background-repeat: no-repeat;
  position: relative;
  top: 3px;
  background-size: 15px 15px;
  margin-left: 5px;
}

/*点击收藏的div*/
.collect-praise .collect {
  cursor: pointer;
}

/*收藏未点亮icon*/
.collect-icon {
  background: url('~@/assets/img/icon-collect.png') no-repeat;
}

/*收藏点亮icon*/
.collect-icon1 {
  background: url('~@/assets/img/icon-collected.png') no-repeat;
}

.collect-person {
  vertical-align: 0px;
}

/*2个收藏icon的公共样式*/
.collect .collect-icon,
.collect-icon1 {
  display: inline-block;
  height: 15px;
  width: 15px;
  vertical-align: -2px;
  background-size: 15px 15px;
}

/* 公共 */
.font-14 {
  font-size: 14px;
}

.content-wth {
  word-break: break-all;
  /* padding-bottom: 60px; */
}

.collect-icon {
  height: 14px;
  width: 14px;
  background-repeat: no-repeat;
  background-image: url('~@/assets/img/icon-collect.png');
  display: inline-block;
}

.praise-icon {
  height: 18px;
  width: 18px;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 629px;
  background-position-y: -44px;
  display: inline-block;
}

.home-icon {
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 502px;
  background-position-y: -75px;
  display: inline-block;
  width: 20px;
  height: 20px;
}

.xinlang-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 0px solid rgba(155, 170, 182, 1);
  border-radius: 50%;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 615px;
  background-position-y: -565px;
}

.weixin-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 0px solid rgba(155, 170, 182, 1);
  border-radius: 50%;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 485px;
  background-position-y: -564px;
}

.fxadd-icon {
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 0px solid rgba(155, 170, 182, 1);
  border-radius: 50%;
  background-image: url('~@/assets/icon/icon.png');
  background-position-x: 549px;
  background-position-y: -564px;
}

.article-detail,
.dw-center {
  text-align: center;
}

.article-detail {
  background-color: #f7f7f7;
}

.article-detail .ad-down .ad-left,
.article-detail .ad-down .ad-right {
  display: inline-block;
  vertical-align: top;
}

/* 上 */
.article-detail>div:first-of-type {
  background: rgba(235, 235, 235, 1);
}

.article-detail .ad-up {
  background: rgba(235, 235, 235, 1);
}

.article-detail .ad-up .nav-bar span {
  vertical-align: middle;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: rgba(118, 118, 118, 1);
}

.article-detail .ad-up .nav-bar span:not(:first-of-type) {
  margin-left: 5px;
}

.article-detail .ad-up .article-title,
.article-detail .ad-up .author-time,
.article-detail .ad-up .intro {
  text-align: center;
}

.article-detail .ad-up .author-time {
  margin-top: 20px;
}

.article-detail .ad-up .intro {
  margin-top: 20px;
  padding-bottom: 20px;
}

.article-detail .author-time .time {
  margin-left: 100px;
}

.article-detail .article-title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(49, 66, 78, 1);
  margin-top: 50px;
}

/* 下 */
.article-detail .ad-down {
  padding-top: 50px;
  position: relative;
  text-align: left;
}

.dw-center,
.article-detail .ad-down {
  width: 1124px;
  display: inline-block;
}

.dw-center {
  text-align: left;
}

/* 下-左 */
.article-detail .ad-down .ad-left .content-info {}

.article-detail .ad-down .ad-left .collect-praise-share {
  position: relative;
  height: 90px;
  font-size: 13px;
  margin-top: 100px;
}

.article-detail .ad-down .ad-left .collect-praise-share .collect-praise {
  position: absolute;
  display: inline-block;
  left: 0px;
}

.article-detail .ad-down .ad-left .collect-praise-share .collect-praise .collect,
.article-detail .ad-down .ad-left .collect-praise-share .collect-praise .praise {
  display: inline-block;
  width: 108px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(210, 210, 210, 1);
  border-radius: 20px;
  text-align: center;
  line-height: 40px;
}

.article-detail .ad-down .ad-left .collect-praise-share .collect-praise .praise {
  margin-left: 12px;
  cursor: pointer;
}

.article-detail .ad-down .ad-left .collect-praise-share .share {
  position: absolute;
  display: inline-block;
  right: 0px;
  height: 50px;
  line-height: 50px;
}

.article-detail .ad-down .ad-left .collect-praise-share .share span {
  vertical-align: middle;
  margin-left: 15px;
}

.article-detail .ad-down .ad-left .relation-article .relation-list {
  margin-top: 17px;
  height: 250px;
}

.article-detail .ad-down .ad-left .relation-article .key-word span {
  display: inline-block;
  padding: 2px 10px;
  min-width: 60px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(210, 210, 210, 1);
  border-radius: 14px;
  text-align: center;
}

.article-detail .ad-down .ad-left .relation-article .key-word span:not(:first-of-type) {
  margin-left: 10px;
}

.article-detail .ad-down .ad-left .relation-article .relation-list .relation-one {
  display: inline-block;
  width: 155px;
  height: 151px;
  vertical-align: top;
}

.article-detail .ad-down .ad-left .relation-article .relation-list .relation-one:not(:first-of-type) {
  margin-left: 33px;
}

/* 下-左-相关文章 */

/* 下-右 */
.article-detail .ad-down .ad-right {
  width: 307px;
  margin-left: 40px;
  cursor: default;
}

.article-detail .ad-down .ad-right .author {
  padding: 50px 20px 20px;
  width: 86.5%;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(225, 225, 225, 1);
}

/* 最新文章 */
.newest {
  margin-top: 50px;
}

.newest .bt {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 34px;
}

.newest-list {
  padding: 20px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(225, 225, 225, 1);
  background: rgba(255, 255, 255, 1);
}

.newest-list .newest-one {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(0, 0, 0, 1);
  line-height: 30px;
}

.newest-list .newest-one:hover {
  cursor: pointer;
}

.newest-list .newest-one:not(:first-of-type) {
  padding-top: 20px;
}

.newest-list .newest-one:not(:last-of-type) {
  border-bottom: 1px solid rgba(225, 225, 225, 1);
  padding-bottom: 20px;
}

.release-amount {
  text-align: center;
  border: 1px solid rgba(225, 225, 225, 1);
  margin-top: 50px;
  background: rgba(255, 255, 255, 1);
}

.release-amount>span {
  font-size: 16px;
  font-weight: 300;
  color: rgba(120, 120, 120, 1);
  line-height: 30px;
}

.release-amount>span>span {
  color: rgba(253, 110, 5, 1);
}

/*文章详情标题简介居中*/
.top18-center {
  width: 100%;
}

.article-detail .gotop {
  text-align: center;
  position: fixed;
  right: 50px;
  bottom: 30px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background: #d6d6d6;
  color: #000;
  transition-duration: 0.5s;
}

.article-detail .gotop:hover {
  transition-duration: 0.5s;
  background: white;
}

/* 文章字体显示样式 */
/* .ad-left .content-wth >>> p {
  line-height: 25px;
  font-size: 16px;
} */
</style>
